import React from 'react';
import { Card, Row, Col } from 'antd';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/free-solid-svg-icons';

interface StatItem {
  title: string;
  value: string | number;
  icon: IconDefinition;
  link: string;
  color: string;
}

interface DashboardStatsProps {
  stats: StatItem[];
}

const DashboardStats: React.FC<DashboardStatsProps> = ({ stats }) => {
  return (
    <Row gutter={[24, 24]} className="mt-6">
      {stats.map((stat, index) => (
        <Col xs={24} sm={12} md={6} key={index}>
          <Link to={stat.link}>
            <Card hoverable className="transition-all duration-200 hover:shadow-lg">
              <div className="flex justify-between items-center">
                <div>
                  <div className="text-sm text-gray-500">{stat.title}</div>
                  <div className="text-2xl font-semibold">{stat.value}</div>
                </div>
                <div className={`text-3xl ${stat.color}`}>
                  <FontAwesomeIcon icon={stat.icon} />
                </div>
              </div>
            </Card>
          </Link>
        </Col>
      ))}
    </Row>
  );
};

export default DashboardStats;
